"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUpDate = exports.polarToCartesian = exports.mapNumber = exports.isValidDate = exports.describeArc = exports.default = exports.THEME = exports.POSITION = exports.LAYOUT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

require("./countdowndatetimer.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// From stackoverflow: https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
const POSITION = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right'
};
exports.POSITION = POSITION;
const LAYOUT = {
  COMPACT: 'compact',
  BAND: 'band'
};
exports.LAYOUT = LAYOUT;
const THEME = {
  PURPLE: 'purple',
  PURPLE_REVERSE: 'purple-reverse',
  WHITE: 'white',
  BLUE: 'blue',
  BLUE_DARK: 'blue-dark',
  MOVISTAR_BLUE_DARK: 'movistar-blue-dark'
};
exports.THEME = THEME;

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

exports.polarToCartesian = polarToCartesian;

const describeArc = (x, y, radius, startAngle, endAngle) => {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  const d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
  return d;
}; // Stackoverflow: https://stackoverflow.com/questions/10756313/javascript-jquery-map-a-range-of-numbers-to-another-range-of-numbers


exports.describeArc = describeArc;

const mapNumber = (number, inmin, inmax, outmin, outmax) => (number - inmin) * (outmax - outmin) / (inmax - inmin) + outmin;

exports.mapNumber = mapNumber;

const isValidDate = dateObj => {
  if (Object.prototype.toString.call(dateObj) === '[object Date]') {
    // it is a date
    if (isNaN(dateObj.getTime())) {
      // d.valueOf() could also work
      // date is not valid
      return false;
    } // date is valid


    return true;
  } // not a date


  return false;
};

exports.isValidDate = isValidDate;

const setUpDate = (startDate, endDate) => {
  const device = (0, _gerenciatdUtils.getDeviceInfo)();
  const {
    browser
  } = device;
  const {
    name: browserName
  } = browser;
  let strDateTimeIniNormalized = startDate;
  let strDateTimeFinNormalized = endDate;

  if (browserName === 'Safari' || browserName === 'Firefox') {
    strDateTimeIniNormalized = strDateTimeIniNormalized.replace(/-/g, '/');
    strDateTimeFinNormalized = strDateTimeFinNormalized.replace(/-/g, '/');
  }

  let dateIni = new Date(strDateTimeIniNormalized);
  const dateFin = new Date(strDateTimeFinNormalized);

  if (strDateTimeIniNormalized == '') {
    dateIni = new Date();
  }

  if (!isValidDate(dateIni)) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  } else {
    if (dateIni <= new Date()) {
      dateIni = new Date();
    } else {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
  }

  if (!isValidDate(dateFin)) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const firstDiff = dateFin.getTime() - dateIni.getTime();

  if (firstDiff < 0) {
    // warn
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const diff = new Date(firstDiff); // const years = diff.getUTCFullYear() - 1970; // Gives difference as year
  // let months = diff.getUTCMonth(); // Gives month count of difference

  const minutes = diff.getUTCMinutes();
  const days = diff.getUTCDate() - 1; // Gives day count of difference

  const seconds = diff.getUTCSeconds();
  const hours = diff.getUTCHours(); // const totalSeconds = diff.getTime() / 1000;

  /* Tanslate to seconds */

  return {
    days,
    hours,
    minutes,
    seconds
  };
};
/**
 * Stateless component to draw a clCountDownTimeraim
 * @param {string} finishTime set when the counter will stop
 * @param {string} colorTheme appearances one of: THEME
 * @returns {JSX} Component JSX.
 */


exports.setUpDate = setUpDate;

class CountDownDateTimer extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "decideCircleColor", (colorTheme, layout) => {
      if (layout == LAYOUT.COMPACT) {
        switch (colorTheme) {
          case THEME.BLUE:
            return {
              counter: '#019df4',
              bg: 'rgba(1, 157, 244, 0.5)'
            };

          case THEME.MOVISTAR_BLUE_DARK:
            return {
              counter: '#0b2739',
              bg: 'rgba(11, 39, 57, 0.5)'
            };

          default:
            return {
              counter: 'white',
              bg: 'rgba(255,255,255, 0.5)'
            };
        }
      } else {
        switch (colorTheme) {
          case THEME.PURPLE_REVERSE:
            return {
              counter: '#954b97',
              bg: 'rgba(182,183,183, 0.35)'
            };

          case THEME.WHITE:
            return {
              counter: 'black',
              bg: 'rgba(255,255,255,1)'
            };

          default:
            return {
              counter: 'white',
              bg: 'rgba(255,255,255, 0.5)'
            };
        }
      }
    });

    const {
      startDate,
      endDate
    } = this.props;
    const duration = setUpDate(startDate, endDate);
    const {
      days,
      hours,
      minutes,
      seconds
    } = duration;
    let _render = false;

    if (duration && (duration.days > 0 || duration.hours > 0 || duration.minutes > 0 || duration.seconds > 0)) {
      _render = true;
    }

    this.state = {
      render: _render,
      days: days || 0,
      hours: hours || 0,
      minutes: minutes || 0,
      seconds: seconds || 0
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const {
        startDate,
        endDate
      } = this.props;
      const duration = setUpDate(startDate, endDate);

      if (duration && (duration.days > 0 || duration.hours > 0 || duration.minutes > 0 || duration.seconds > 0)) {
        const {
          days,
          hours,
          minutes,
          seconds
        } = duration;
        this.setState({
          render: true,
          days,
          hours,
          minutes,
          seconds
        });
      } else {
        this.setState({
          render: false,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const {
      colorTheme,
      components,
      position,
      visibleItems,
      layout
    } = this.props;
    const {
      visibleDays,
      visibleHours,
      visibleMinutes,
      visibleSeconds
    } = visibleItems;
    const textInfo = components && components['TextInfo-1'];
    const iconLoader = components && components['SvgIconLoader-1'];
    const circleColor = this.decideCircleColor(colorTheme, layout);
    const {
      days,
      hours,
      minutes,
      render
    } = this.state;
    let {
      seconds
    } = this.state;
    const daysRadius = mapNumber(days, 30, 0, 0, 360);
    const hoursRadius = mapNumber(hours, 24, 0, 0, 360);
    const minutesRadius = mapNumber(minutes, 60, 0, 0, 360);
    const secondsRadius = mapNumber(seconds, 60, 0, 0, 360);

    if (seconds < 0) {
      seconds = 0;
    }

    let fadeOutCss = '';

    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
      fadeOutCss = ' countdown-wrapper--fadeout';
    }

    if (!render) {
      return null;
    }

    if (layout == LAYOUT.COMPACT) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `countdown-wrapper-${layout}${fadeOutCss} --theme-${colorTheme}-${layout}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "container countdown_container_main",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "countdown_text",
            children: [iconLoader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread({}, iconLoader)), textInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, textInfo))]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `countdown_container countdown_container--${position}`,
            children: [visibleDays && days >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item days",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: daysRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: days
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "d\xEDas"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "d\xEDas"
              })]
            }), visibleHours && hours >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item hours",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: hoursRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: hours
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "h"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "h"
              })]
            }), visibleMinutes && minutes >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item minutes",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: minutesRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: minutes
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "min"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "min"
              })]
            }), visibleSeconds && seconds >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item seconds",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: secondsRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: seconds
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "s"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "s"
              })]
            })]
          })]
        })
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `countdown-wrapper-${layout}${fadeOutCss} --theme-${colorTheme}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "container countdown_container_main",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "countdown_text",
            children: [iconLoader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread({}, iconLoader)), textInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, textInfo))]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `countdown_container countdown_container--${position}`,
            children: [visibleDays && days >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item days",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: daysRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: days
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "d\xEDas"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "d\xEDas"
              })]
            }), visibleHours && hours >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item hours",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: hoursRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: hours
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "horas"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "horas"
              })]
            }), visibleMinutes && minutes >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item minutes",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: minutesRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: minutes
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "minutos"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "minutos"
              })]
            }), visibleSeconds && seconds >= 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "countdown-time-item seconds",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "countdown-item",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.bg,
                  radius: 359.999
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGCircle, {
                  color: circleColor.counter,
                  radius: secondsRadius
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "number",
                  children: seconds
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label pc",
                children: "segundos"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "label mobile",
                children: "segundos"
              })]
            })]
          })]
        })
      });
    }
  }

}

const SVGCircle = _ref => {
  let {
    radius,
    color
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    className: "countdown-svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "4",
      d: describeArc(50, 50, 48, 0, radius)
    })
  });
};

CountDownDateTimer.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
  count: 1,
  height: 100
});

CountDownDateTimer.propTypes = {
  /**
   * {
   *  "info": "Componente TextInfo junto a sus props",
   *  "kind": "both",
   *  "beautifulName": "TextInfo-1"
   * }
   */
  components: _propTypes.default.object,

  /**
   * {
   *  "info": "Tiempo de duración del contador",
   *  "kind": "both",
   *  "beautifulName": "Duración"
   * }
   */
  finishTime: _propTypes.default.string,

  /**
   * {
   *  "info": "Tema del contador, sirve para definir el color del texto, el color de background, la alineación del texto,... ",
   *  "kind": "both",
   *  "beautifulName": "Tema"
   * }
   */
  colorTheme: _propTypes.default.oneOf([THEME.PURPLE, THEME.PURPLE_REVERSE, THEME.WHITE, THEME.BLUE, THEME.BLUE_DARK, THEME.MOVISTAR_BLUE_DARK]),

  /**
   * {
   *  "info": "Posicion de los contadores",
   *  "kind": "both",
   *  "beautifulName": "position"
   * }
   */
  position: _propTypes.default.oneOf([POSITION.CENTER, POSITION.RIGHT, POSITION.LEFT]),

  /**
   * {
   *  "info": "flag para visibilizar los días ,horas minutos o segundos",
   *  "kind": "both",
   *  "beautifulName": "visibleSeconds"
   * }
   */
  visibleItems: _propTypes.default.Object
};
CountDownDateTimer.defaultProps = {
  components: {},
  startDate: '',
  endDate: '',
  colorTheme: THEME.PURPLE,
  position: POSITION.CENTER,
  layout: LAYOUT.BAND,
  visibleItems: {
    visibleDays: true,
    visibleHours: true,
    visibleMinutes: true,
    visibleSeconds: true
  }
};
var _default = CountDownDateTimer;
exports.default = _default;

//# sourceMappingURL=index.js.map